import { render, staticRenderFns } from "./SelfAssessment.vue?vue&type=template&id=aad051b4&scoped=true"
import script from "./SelfAssessment.vue?vue&type=script&lang=js"
export * from "./SelfAssessment.vue?vue&type=script&lang=js"
import style0 from "./SelfAssessment.vue?vue&type=style&index=0&id=aad051b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad051b4",
  null
  
)

export default component.exports